import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/recaudacion/clases-de-vehiculos/';

/**
 * GET ClasesDeVehiculos
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getClasesDeVehiculos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET ClaseDeVehiculo
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getClaseDeVehiculos = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST ClaseDeVehiculo
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postClaseDeVehiculos = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH SectorDeVehiculos
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchClaseDeVehiculos = async (id, _values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, _values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE SectorDeVehiculos
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteClaseDeVehiculos = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
